<template>
  <span>
    <b-button class="mr-2"
              variant="edit"
              @click="showTaskModal(task)"
              qid="delete-s-cancel-button"
              v-if="!editIcon"
    >
      <span v-if="task">
        <font-awesome-icon icon="pen"/>
      </span>
      <span v-if="!task">
        {{ $t('tasks.open_first_task') }}
      </span>
    </b-button>

    <span v-else @click="showTaskModal(task)">
      <span v-if="buttonStyle">
        <span class="btn btn-sm btn-success cursor-pointer">
          {{ $t('tasks.open_label') }}
        </span>
      </span>
      <span v-else>
        <font-awesome-icon icon="info-circle" class="text-primary"/>
        {{ $t('tasks.open_label') }}
      </span>
    </span>

    <!-- Task modal -->
    <b-modal ref="task-modal" @hide="hideTaskModal" size="xl" modal-class="bottom-left task-modal">

      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="hideTaskModal" class="btn btn-secondary cursor-pointer float-right">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center" v-if="selectedTask && selectedTask.id && selectedTask.model">
            {{ $t('tasks.values.' + $options.filters.slugify(selectedTask.title)) }}
            {{ $t('system.on') }}
            <span v-if="selectedTask.model.who_am_i == 'App\\System\\Models\\System'">
              {{ $t('system.the_system') }}
            </span>
            <span v-if="selectedTask.model.who_am_i == 'App\\Activity\\Models\\Activity'">
              {{ $t('system.the_activity') }}
            </span>
            <span v-if="selectedTask.model.who_am_i == 'App\\Process\\Models\\Process'">
              {{ $t('system.the_process') }}
            </span>
            <span v-if="selectedTask.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'">
              {{ $t('system.the_contract') }}
            </span>
            <span v-if="selectedTask.model.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy'">
              {{ $t('system.the_policy') }}
            </span>
            <span class="breadcrumb-item ml-2">
              <a @click="navigateToTask(selectedTask)">
                <font-awesome-icon icon="desktop" class="mr-1" v-if="selectedTask.model.who_am_i == 'App\\System\\Models\\System'"/>
                <font-awesome-icon icon="cubes" class="mr-1" v-if="selectedTask.model.who_am_i == 'App\\Activity\\Models\\Activity'"/>
                <font-awesome-icon icon="cube" class="mr-1" v-if="selectedTask.model.who_am_i == 'App\\Process\\Models\\Process'"/>
                <font-awesome-icon icon="file-signature" class="mr-1" v-if="selectedTask.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'"/>
                <font-awesome-icon icon="file-invoice" class="mr-1" v-if="selectedTask.model.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy'"/>

                {{ selectedTask.model.name }}
              </a>
            </span>
            <span v-if="selectedTask.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'">
              {{ $t('system.with') }}
              <Avatar :object="selectedTask.model.vendors[0]" size="xs"></Avatar>
              <span class="ml-1">{{ selectedTask.model.vendors[0].name }}</span>
            </span>
          </h5>
          <div class="row mt-3 pt-4 pb-1 pl-5 pr-5" v-if="selectedTask && selectedTask.id">
            <div class="col-sm-6"
                 v-if="getGuide(selectedTask.code)"
            >
              <b-form-group>
                <div class="">
                  <span class="btn btn-secondary btn-xs float-right cursor-pointer" @click="openGuide()">
                    <font-awesome-icon icon="eye" />
                    {{ $t('administration.guide.modal.button') }}
                  </span>
                  <label qid="create-p-users-label">
                    {{ $t('system.help_center_label') }}
                  </label>
                  <div v-if="wpGuide && wpGuide.id" class="guide-content-container">
                    <p v-if="!showFullGuideDescription" v-html="wpGuide.excerpt.rendered"></p>
                    <p v-if="showFullGuideDescription" v-html="wpGuide.content.rendered"></p>

                    <div class="text-center mt-3" @click="showFullGuideDescription=!showFullGuideDescription">
                      <span class="cursor-pointer" v-if="!showFullGuideDescription">
                        <span class="mr-2">
                          {{ $t('system.view_more') }}
                        </span>
                        <font-awesome-icon icon="chevron-down"/>
                      </span>
                      <span class="cursor-pointer" v-if="showFullGuideDescription">
                        <span class="mr-2">
                          {{ $t('system.view_less') }}
                        </span>
                        <font-awesome-icon icon="chevron-up"/>
                      </span>
                    </div>
                  </div>
                </div>
              </b-form-group>
            </div>
            <div :class="{'col-sm-6': getGuide(selectedTask.code), 'col-sm-12': !getGuide(selectedTask.code)}">
              <b-form-group>
                <div class="">
                  <span class="btn btn-secondary btn-xs float-right cursor-pointer" @click="openWelcomePage()" v-if="welcomeGuide && welcomeGuide.id">
                    <font-awesome-icon icon="eye" />
                    {{ $t('system.welcome_page_button') }}
                  </span>
                  <label qid="create-p-users-label">
                    <font-awesome-icon icon="calendar-alt" class="mr-2"/>
                    {{ selectedTask.project.title }}
                  </label>
                  <div v-if="selectedTask.project.schedule_message && selectedTask.project.schedule_message.length > 300">
                    <p v-if="showFullProjectMessage" class="text-formatted">
                      {{ selectedTask.project.schedule_message }}
                    </p>
                    <p v-if="!showFullProjectMessage" class="text-formatted">
                      {{ selectedTask.project.schedule_message | truncate(300) }}
                    </p>
                    <div class="text-center mt-3" @click="showFullProjectMessage=!showFullProjectMessage">
                      <span class="cursor-pointer" v-if="!showFullProjectMessage">
                        <span class="mr-2">
                          {{ $t('system.view_more') }}
                        </span>
                        <font-awesome-icon icon="chevron-down"/>
                      </span>
                      <span class="cursor-pointer" v-if="showFullProjectMessage">
                        <span class="mr-2">
                          {{ $t('system.view_less') }}
                        </span>
                        <font-awesome-icon icon="chevron-up"/>
                      </span>
                    </div>
                  </div>
                  <p v-if="selectedTask.project.schedule_message && selectedTask.project.schedule_message.length <= 300"
                     class="text-formatted"
                  >
                    {{ selectedTask.project.schedule_message }}
                  </p>
                </div>
                <div class="mt-2 mb-1" v-if="selectedTask.project.media">
                  <p v-for="file in selectedTask.project.media">
                    <span class="mr-3 float-right text-muted cursor-pointer"
                          @click="downloadMedia(file)"
                          qid="download-media"
                    >
                      <font-awesome-icon icon="cloud-download-alt" />
                    </span>
                    <a @click="downloadMedia(file)" qid="create-p-media-item">
                      {{ file.file_name }}
                    </a>
                  </p>
                </div>

                <div class="" v-if="selectedTask.project.links">
                  <p v-for="link in selectedTask.project.links" >
                    <a :href="link.url" target="_blank" qid="create-p-link-item">
                      {{ link.name ? link.name : link.url }}
                    </a>
                  </p>
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-p-error"
      >
        {{ error }}
      </b-alert>
      <b-form qid="create-p-form" v-if="selectedTask && selectedTask.model">
        <div class="form-container mt-0 mb-2">

          <div class="row mt-1">

            <!-- Tables container -->
            <div class="col-sm-12">

              <!-- Activities -->
              <div v-if="selectedTask && selectedTask.model && selectedTask.model.who_am_i == 'App\\Activity\\Models\\Activity'">
                <div v-if="selectedTask.code == 'update_basic_info'">
                  <BasicInfoBlockActivity :object="selectedTask.model" :showOnTask="true" :submitForm="submitForm" :task="selectedTask" @reloadContent="updateTasks"></BasicInfoBlockActivity>
                </div>
                <div v-if="selectedTask.code == 'update_description'">
                  <DescriptionBlock :object="selectedTask.model" :showOnTask="true" :task="selectedTask" :submitForm="submitForm"></DescriptionBlock>
                </div>
                <div v-if="selectedTask.code == 'update_organization'">
                  <OrganizationsTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></OrganizationsTable>
                </div>
                <div v-if="selectedTask.code == 'update_policies_and_procedures'">
                  <PoliciesAndProceduresTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></PoliciesAndProceduresTable>
                </div>
                <div v-if="selectedTask.code == 'update_mapping_description'">
                  <MappingDescriptionBlock :object="selectedTask.model" :showOnTask="true" :task="selectedTask" :submitForm="submitForm"></MappingDescriptionBlock>
                </div>
                <div v-if="selectedTask.code == 'update_systems'">
                  <SystemTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></SystemTable>
                </div>
                <div v-if="selectedTask.code == 'update_third_party_sources'">
                  <ThirdPartySourcesTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></ThirdPartySourcesTable>
                </div>
                <div v-if="selectedTask.code == 'update_third_party_receivers'">
                  <ThirdPartyReceiversTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></ThirdPartyReceiversTable>
                </div>
                <div v-if="selectedTask.code == 'update_processing_role'">
                  <ProcessingRole :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></ProcessingRole>
                </div>
                <div v-if="selectedTask.code == 'update_data_subject'">
                  <DataSubjectsTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></DataSubjectsTable>
                </div>
                <div v-if="selectedTask.code == 'update_retention_rule'">
                  <RetentionRulesTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></RetentionRulesTable>
                </div>
                <div v-if="selectedTask.code == 'update_integrity_check'">
                  <IntegrityCheck :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></IntegrityCheck>
                </div>
                <div v-if="selectedTask.code == 'update_processing_type'">
                  <ProcessingType :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></ProcessingType>
                </div>
                <div v-if="selectedTask.code == 'update_risk_scenarios'">
                  <RiskScenariosTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></RiskScenariosTable>
                </div>
                <div v-if="selectedTask.code == 'update_measures'">
                  <ActivityMeasuresTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></ActivityMeasuresTable>
                </div>
              </div>

              <!-- Systems -->
              <div v-if="selectedTask && selectedTask.model && selectedTask.model.who_am_i == 'App\\System\\Models\\System'">
                <div v-if="selectedTask.code == 'update_basic_info'">
                  <BasicInfoBlockSystem :object="selectedTask.model" :showOnTask="true" :submitForm="submitForm" :task="selectedTask" @reloadContent="updateTasks"></BasicInfoBlockSystem>
                </div>
                <div v-if="selectedTask.code == 'update_description'">
                  <DescriptionBlockSystem :object="selectedTask.model" :showOnTask="true" :task="selectedTask" :submitForm="submitForm"></DescriptionBlockSystem>
                </div>
                <div v-if="selectedTask.code == 'update_policies_and_procedures'">
                  <PoliciesAndProceduresTableSystem :object="selectedTask.model" :showOnTask="true"></PoliciesAndProceduresTableSystem>
                </div>
                <div v-if="selectedTask.code == 'update_third_parties'">
                  <ThirdPartiesTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></ThirdPartiesTable>
                </div>
                <div v-if="selectedTask.code == 'update_data_objects'">
                  <DataObjectsTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></DataObjectsTable>
                </div>
                <div v-if="selectedTask.code == 'update_access_control'">
                  <AccessControlTable :system="selectedTask.model" :showOnTask="true"></AccessControlTable>
                </div>
                <div v-if="selectedTask.code == 'update_log_management'">
                  <LogManagementTable :system="selectedTask.model" :showOnTask="true" :task="selectedTask"></LogManagementTable>
                </div>
                <div v-if="selectedTask.code == 'update_network'">
                  <NetworkTable :system="selectedTask.model" :showOnTask="true" :task="selectedTask"></NetworkTable>
                </div>
                <div v-if="selectedTask.code == 'update_data_discovery'">
                  <DataDiscoveryTable :system="selectedTask.model" :showOnTask="true" :task="selectedTask"></DataDiscoveryTable>
                </div>
                <div v-if="selectedTask.code == 'update_risk_scenarios'">
                  <RiskScenariosTableSystem :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></RiskScenariosTableSystem>
                </div>
                <div v-if="selectedTask.code == 'update_measures'">
                  <SystemMeasuresTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></SystemMeasuresTable>
                </div>
              </div>

              <!-- Processes -->
              <div v-if="selectedTask && selectedTask.model && selectedTask.model.who_am_i == 'App\\Process\\Models\\Process'">
                <div v-if="selectedTask.code == 'update_basic_info'">
                  <BasicInfoBlockProcess :object="selectedTask.model" :showOnTask="true" :submitForm="submitForm" :task="selectedTask" @reloadContent="updateTasks"></BasicInfoBlockProcess>
                </div>
                <div v-if="selectedTask.code == 'update_description'">
                  <DescriptionBlockProcess :object="selectedTask.model" :showOnTask="true" :task="selectedTask" :submitForm="submitForm"></DescriptionBlockProcess>
                </div>
                <div v-if="selectedTask.code == 'update_purpose'">
                  <PurposeBlock :object="selectedTask.model" :showOnTask="true" :task="selectedTask" :submitForm="submitForm"></PurposeBlock>
                </div>
                <div v-if="selectedTask.code == 'update_policies_and_procedures'">
                  <PoliciesAndProceduresTableProcess :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></PoliciesAndProceduresTableProcess>
                </div>
                <div v-if="selectedTask.code == 'update_legal_basis'">
                  <LegalBasisTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></LegalBasisTable>
                </div>
                <div v-if="selectedTask.code == 'update_information_obligation'">
                  <InformationObligationTable :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></InformationObligationTable>
                </div>
                <div v-if="selectedTask.code == 'update_risk_profile'">
                  <Riskprofile :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></Riskprofile>
                </div>
                <div v-if="selectedTask.code == 'update_loss_of_confidentiality'">
                  <Confidentiality :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></Confidentiality>
                </div>
                <div v-if="selectedTask.code == 'update_loss_of_integrity'">
                  <Integrity :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></Integrity>
                </div>
                <div v-if="selectedTask.code == 'update_loss_of_availability'">
                  <Availability :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></Availability>
                </div>
                <div v-if="selectedTask.code == 'update_risk_scenarios'" :task="selectedTask">
                  <RiskScenariosTableProcess :object="selectedTask.model" :showOnTask="true" :task="selectedTask"></RiskScenariosTableProcess>
                </div>
              </div>

              <!-- Third parties -->
              <div v-if="selectedTask && selectedTask.model && selectedTask.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty'">
                <div v-if="selectedTask.code == 'update_basic_info'">
                  <BasicInfoBlockTP :object="selectedTask.model" :showOnTask="true" :submitForm="submitForm" :task="selectedTask" @reloadContent="updateTasks"></BasicInfoBlockTP>
                </div>
                <div v-if="selectedTask.code == 'update_description'">
                  <DescriptionBlockThirdParty :object="selectedTask.model" :showOnTask="true" :submitForm="submitForm"></DescriptionBlockThirdParty>
                </div>
                <div v-if="selectedTask.code == 'update_risk_scenarios'">
                  <RiskScenariosTableThirdParty :object="selectedTask.model" :showOnTask="true"></RiskScenariosTableThirdParty>
                </div>
                <div v-if="selectedTask.code == 'update_documents'">
                  <DocumentsTableThirdParty :object="selectedTask.model" :showOnTask="true"></DocumentsTableThirdParty>
                </div>
                <div v-if="selectedTask.code == 'update_contacts'">
                  <ContactsTableThirdParty :object="selectedTask.model" :showOnTask="true"></ContactsTableThirdParty>
                </div>
                <div v-if="selectedTask.code == 'update_measures'">
                  <MeasuresTableThirdParty :object="selectedTask.model" :showOnTask="true"></MeasuresTableThirdParty>
                </div>
                <div v-if="selectedTask.code == 'update_subdata_processors'">
                  <SubDataProcessors :object="selectedTask.model" :showOnTask="true"></SubDataProcessors>
                </div>
                <div v-if="selectedTask.code == 'update_data_processor_agreement'">
                  <DataProcessorAgreement :object="selectedTask.model" :showOnTask="true"></DataProcessorAgreement>
                </div>
              </div>

              <!-- Policies and procedures -->
              <div v-if="selectedTask && selectedTask.model && selectedTask.model.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy'">
                <div v-if="selectedTask.code == 'update_basic_info'">
                  <BasicInfoBlockPolicy :object="selectedTask.model" :showOnTask="true" :submitForm="submitForm" @reloadContent="updateTasks"></BasicInfoBlockPolicy>
                </div>
                <div v-if="selectedTask.code == 'update_description'">
                  <DescriptionBlockPolicy :object="selectedTask.model" :showOnTask="true" :submitForm="submitForm"></DescriptionBlockPolicy>
                </div>
                <div v-if="selectedTask.code == 'update_documents'">
                  <DocumentsTablePolicy :object="selectedTask.model" :showOnTask="true"></DocumentsTablePolicy>
                </div>
              </div>

            </div>

          </div>

        </div>

      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="task-modal-info" v-if="selectedTask && selectedTask.id">
            <div class="row">
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('projects.create.task_assignees') }}</strong>
                </div>
                <span class="mr-1 text-normal" v-if="selectedTask.users && selectedTask.users.length" v-for="user in getReducedUsers(selectedTask.users)">
                  <span qid="profile-photo">
                    <Avatar :object="user" size="xs"></Avatar>
                  </span>
                </span>
                <span v-if="selectedTask.users && selectedTask.users.length && selectedTask.users.length > 3"
                      class="badge cursor-pointer"
                      @click="openUsersModal(selectedTask)"
                >
                  <font-awesome-icon icon="users"/>
                  + {{ selectedTask.users.length - 3 }}
                </span>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('table.due_date') }}</strong>
                </div>
                <span class="text-normal">
                  <span v-if="getDifference(selectedTask.project.end_date) > 3">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-1"/>
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span v-if="getDifference(selectedTask.project.end_date) <= 3 && getDifference(selectedTask.project.end_date) >= 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-6"/>
                    {{ $t('system.due_in') }}
                    {{ getDifference(selectedTask.project.end_date) }}
                    {{ $t('system.days') }}
                  </span>
                  <span v-if="getDifference(selectedTask.project.end_date) < 0">
                    <font-awesome-icon icon="exclamation-triangle" class="risk-12"/>
                    {{ Math.abs(getDifference(selectedTask.project.end_date)) }}
                    {{ $t('system.days') }}
                    {{ $t('system.overdue') }}
                  </span>
                </span>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('system.task_status') }}</strong>
                </div>
                <span v-if="selectedTask.status === 'completed'" >
                  <font-awesome-icon icon="check-circle" class="icon-success"/>
                </span>
                <span v-if="selectedTask.status === 'pending'" class="pr-2">
                  <font-awesome-icon
                      icon="exclamation-triangle"
                      class="risk-6"
                  />
                </span>
                <span class="text-normal">
                  {{ $t('system.' + $options.filters.slugify(selectedTask.status)) }}
                </span>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('table.project') }}</strong>
                </div>
                <span v-if="isOwner(selectedTask.project)" class="text-success breadcrumb-item cursor-pointer" @click="navigateToProject(selectedTask)">
                  <font-awesome-icon icon="calendar-alt" class="mr-1"/>
                  {{ selectedTask.project.title }}
                </span>
                <span v-if="!isOwner(selectedTask.project)" class="text-success breadcrumb-item" style="pointer-events:none;">
                  <font-awesome-icon icon="calendar-alt" class="mr-1"/>
                  {{ selectedTask.project.title }}
                </span>
              </div>
              <div class="col text-center pt-3 pb-3">
                <div class="mb-3">
                  <strong>{{ $t('projects.create.owners_label') }}</strong>
                </div>
                <span class="mr-1 text-normal" v-for="user in getReducedUsers(selectedTask.users)">
                  <span qid="profile-photo">
                    <Avatar :object="user" size="xs"></Avatar>
                  </span>
                </span>
                <span v-if="selectedTask.users && selectedTask.users.length > 3"
                      class="badge cursor-pointer"
                      @click="openUsersModal(selectedTask)"
                >
                  <font-awesome-icon icon="users"/>
                  + {{ selectedTask.users.length - 3 }}
                </span>
              </div>
            </div>
          </div>
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">
                <span>
                  <vm-progress
                      type="circle"
                      :percentage="project_progress"
                      style="vertical-align: middle;"
                      :width="50"
                      :stroke-width="2"
                      stroke-color="#00c29e"
                  >
                    {{project_progress}}%
                  </vm-progress>
                </span>
              </div>
              <div class="col-sm-6 text-right">
                <b-button class="ml-3 mt-2"
                          variant="success"
                          @click="completeTask()"
                          v-if="selectedTask.status != 'completed'"
                          :disabled="buttonDisabled"
                          qid="create-p-cancel-button"
                >
                  {{ $t('tasks.modal.complete') }}
                </b-button>
                <b-button class="ml-3 mt-2"
                          variant="success"
                          v-if="selectedTask.status != 'completed'"
                          @click="saveTask()"
                          :disabled="buttonDisabled"
                          qid="create-p-cancel-button"
                >
                  {{ $t('system.close') }}
                </b-button>
                <b-button class="ml-3 mt-2"
                          variant="success"
                          v-if="selectedTask.status == 'completed'"
                          @click="saveTask()"
                          :disabled="buttonDisabled"
                          qid="create-p-cancel-button"
                >
                  {{ $t('system.save') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>

      </template>

    </b-modal>


    <ConfirmRemoveAttachment
        :object="selectedFile"
        :show="showDeleteAttachmentModal"
        type="file"
        @closeConfirmModal="closeDeleteAttachmentModal"
    ></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment
        :object="selectedLink"
        :show="showDeleteLinkModal"
        type="link"
        @closeConfirmModal="closeDeleteLinkModal"
    ></ConfirmRemoveAttachment>

    <GuideViewModal
        :guide="selectedGuide"
        :showModal="viewGuideModal"
        @closeViewModal="closeViewGuideModal"
    ></GuideViewModal>

    <GuideWatchVideoModal
        :guide="selectedGuide"
        :showModal="viewWatchVideoModal"
        @closeWatchVideoModal="closeWatchVideoGuideModal"
    ></GuideWatchVideoModal>

    <ShowMoreModal
        :items="selectedItem.users"
        :show="showUsersModal"
        @closeViewModal="closeUsersModal"
        type="users"
    ></ShowMoreModal>

  </span>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Datepicker from 'vuejs-datepicker';
  import {config} from '@/config.js';
  import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';
  import GuideViewModal from '@/components/guide/GuideViewModal.vue';
  import GuideWatchVideoModal from '@/components/guide/GuideWatchVideoModal.vue';
  import Avatar from '@/components/Avatar.vue';
  import ShowMoreModal from '@/components/ShowMoreModal.vue';
  import roleCheck from "@/util/ACL/roleCheck"


  // Imports of components are moved to components block
  // Because of circular references between components


  export default {
    name: 'UpdateSingleTaskModal',
    data: function() {
      return {
        taskForm: {
          remarks: ''
        },
        selectedTask: [],
        taskList: [],
        selectedAnswer: [],
        allAnswers: [
          { name: this.$t('tasks.modal.pass'), value: 'pass' },
          { name: this.$t('tasks.modal.fail'), value: 'fail' }
        ],
        buttonDisabled: false,
        selectedFile: {},
        selectedLink: {},
        showDeleteAttachmentModal: false,
        showDeleteLinkModal: false,
        showInput: false,
        showSingleLinkLabel: true,
        inputLink: '',
        descriptionLength: config.descriptionLength,
        showFullProjectMessage: false,
        showFullGuideDescription: false,
        showFullGenericControlDescription: false,
        showFullGenericControlPassedDescription: false,
        showFullGenericControlFailedDescription: false,
        error: '',
        selectedGuide: {},
        viewGuideModal: false,
        viewWatchVideoModal: false,
        myGuides: [],
        project_progress: 0,
        taskCompleted: false,
        submitForm: false,
        updatePageOnClose: false,
        welcomeGuide: {},
        wpGuide: {},
        selectedItem: {},
        showUsersModal: false
      }
    },
    props: {
      task: {},
      type: {},
      tasks: {},
      editIcon: {},
      activeGuide: {},
      buttonStyle: {}
    },
    components: {
      Datepicker,
      ConfirmRemoveAttachment,
      GuideViewModal,
      GuideWatchVideoModal,
      Avatar,
      ShowMoreModal,
      DataSubjectsTable: () => import('@/views/Activities/DataSubjectsTable.vue'),
      RetentionRulesTable: () => import('@/views/Activities/RetentionRulesTable.vue'),
      SystemTable: () => import('@/views/Activities/SystemTable.vue'),
      ThirdPartySourcesTable: () => import('@/views/Activities/ThirdPartySourcesTable.vue'),
      ThirdPartyReceiversTable: () => import('@/views/Activities/ThirdPartyReceiversTable.vue'),
      IntegrityCheck: () => import('@/views/Activities/IntegrityCheck.vue'),
      ProcessingType: () => import('@/views/Activities/ProcessingType.vue'),
      ProcessingRole: () => import('@/views/Activities/ProcessingRole.vue'),
      RiskScenariosTable: () => import('@/views/Activities/RiskScenariosTable.vue'),
      DataDiscoveryTable: () => import('@/views/Systems/DataDiscoveryTable.vue'),
      AccessControlTable: () => import('@/views/Systems/AccessControlTable.vue'),
      NetworkTable: () => import('@/views/Systems/NetworkTable.vue'),
      LogManagementTable: () => import('@/views/Systems/LogManagementTable.vue'),
      RiskScenariosTableSystem: () => import('@/views/Systems/RiskScenariosTable.vue'),
      Confidentiality: () => import('@/views/Processes/Confidentiality.vue'),
      Riskprofile: () => import('@/views/Processes/Riskprofile.vue'),
      Integrity: () => import('@/views/Processes/Integrity.vue'),
      Availability: () => import('@/views/Processes/Availability.vue'),
      RiskScenariosTableProcess: () => import('@/views/Processes/RiskScenariosTable.vue'),
      PoliciesAndProceduresTable: () => import('@/views/Activities/PoliciesAndProceduresTable.vue'),
      OrganizationsTable: () => import('@/views/Activities/OrganizationsTable.vue'),
      PoliciesAndProceduresTableSystem: () => import('@/views/Systems/PoliciesAndProceduresTable.vue'),
      ThirdPartiesTable: () => import('@/views/Systems/ThirdPartiesTable.vue'),
      DataObjectsTable: () => import('@/views/Systems/DataObjectsTable.vue'),
      DescriptionBlockSystem: () => import('@/views/Systems/DescriptionBlock.vue'),
      DescriptionBlock: () => import('@/views/Activities/DescriptionBlock.vue'),
      MappingDescriptionBlock: () => import('@/views/Activities/MappingDescriptionBlock.vue'),
      DescriptionBlockProcess: () => import('@/views/Processes/DescriptionBlock.vue'),
      PurposeBlock: () => import('@/views/Processes/PurposeBlock.vue'),
      PoliciesAndProceduresTableProcess: () => import('@/views/Processes/PoliciesAndProceduresTable.vue'),
      LegalBasisTable: () => import('@/views/Processes/LegalBasisTable.vue'),
      InformationObligationTable: () => import('@/views/Processes/InformationObligationTable.vue'),
      BasicInfoBlockTP: () => import('@/views/ThirdParty/BasicInfoTaskBlock.vue'),
      BasicInfoBlockProcess: () => import('@/views/Processes/BasicInfoTaskBlock.vue'),
      BasicInfoBlockSystem: () => import('@/views/Systems/BasicInfoTaskBlock.vue'),
      RiskScenariosTableThirdParty: () => import('@/views/ThirdParty/RiskScenariosTable.vue'),
      SystemMeasuresTable: () => import('@/views/Systems/MeasuresTable.vue'),
      ActivityMeasuresTable: () => import('@/views/Activities/MeasuresTable.vue'),
      BasicInfoBlockActivity: () => import('@/views/Activities/BasicInfoTaskBlock.vue'),
      DescriptionBlockPolicy: () => import('@/views/Policies/DescriptionBlock.vue'),
      BasicInfoBlockPolicy: () => import('@/views/Policies/BasicInfoTaskBlock.vue'),
      DocumentsTablePolicy: () => import('@/views/Policies/DocumentsTable.vue'),
      DescriptionBlockThirdParty: () => import('@/views/ThirdParty/DescriptionBlock.vue'),
      DocumentsTableThirdParty: () => import('@/views/ThirdParty/DocumentsTable.vue'),
      ContactsTableThirdParty: () => import('@/views/ThirdParty/ContactsTable.vue'),
      MeasuresTableThirdParty: () => import('@/views/ThirdParty/MeasuresTable.vue'),
      SubDataProcessors: () => import('@/views/ThirdParty/SubDataProcessors.vue'),
      DataProcessorAgreement: () => import('@/views/ThirdParty/DataProcessorAgreement.vue')

    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getUser() {
        return this.$store.state.user
      },
      getWordpressLink() {
        return this.$store.state.wordpressLink
      },
    },
    watch: {
      getClient: function () {

      }
    },
    methods: {
      openGuide() {
        if (this.wpGuide && this.wpGuide.link) {
          window.open(this.wpGuide.link, '_blank')
        }
      },
      isOwner(object) {
        let self = this;
        let allow = false;
        let existingUser = _.find(object.users, function(user) {
          return user.id == self.getUser.id
        });

        if (existingUser) {
          allow = true
        } else {
          if (roleCheck('Client admin') || roleCheck('Partition admin') || this.getUser.isAdmin) {
            allow = true
          }
        }

        return allow
      },
      getDifference(endDate) {
        var moment = require('moment');
        let currentDate = moment()
        endDate = moment(endDate);
        let difference = endDate.diff(currentDate, 'days');
        return difference;
      },
      getReducedUsers(users) {
        let reducedUsers = []
        if (users) {
          if (users.length > 3) {
            reducedUsers = _.cloneDeep(users);
            reducedUsers = reducedUsers.slice(0, 3);
          } else {
            reducedUsers = users;
          }
        }
        return reducedUsers;
      },
      openUsersModal(object) {
        this.selectedItem = object
        this.showUsersModal = true
      },
      closeUsersModal() {
        this.selectedItem = {}
        this.showUsersModal = false
      },
      showTaskModal(object) {

        let self = this;
        this.error = '';

        if (object != null) {
          self.selectedTask = object
        }

        if (object == null && this.tasks && this.tasks.length) {
          self.selectedTask = this.tasks[0]
        }

        this.loadTaskById(this.selectedTask.id, true);
        this.loadGuides(this.selectedTask.code)

        this.populateForm()
        this.$refs['task-modal'].show()
        this.loadTaskGuide()
      },
      updateTasks(model) {
        this.updatePageOnClose = true;
      },
      hideTaskModal() {
        // Kept so the task can be opened again from the sidebar
        this.$store.commit('storeLastClosedTask', this.selectedTask);
        let self = this;
        this.error = '';

        setTimeout(function(){
          self.$emit('reloadContent');
          self.selectedTask = {}
        }, 800);

        if (!this.taskCompleted && this.selectedTask.status != 'completed') {
          this.minimizeTask();
        }

        if (this.taskCompleted) {
          self.$store.commit('storeReloadTasks');
        }

        if (this.updatePageOnClose) {
          this.$store.commit('storeUpdatePage', true);
        }

        this.$refs['task-modal'].hide()
      },
      populateForm() {
        let self = this;

        self.taskForm.remarks = self.selectedTask.remarks

        self.selectedAnswer = []
        if (self.selectedTask.response) {
          self.selectedAnswer = _.find(self.allAnswers, function(item) {
            if(item.value === self.selectedTask.response){
              return self.selectedTask.response;
            }
          });
        }
      },
      openWelcomePage() {
        this.showViewGuideModal(this.welcomeGuide)
      },
      loadTaskGuide() {
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';
        let self = this;
        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Task',
            scope: 'update_task',
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.welcomeGuide = response.data.items[0]
          }
        }, function() {});
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        if (object.model_type == 'App\\Activity\\Models\\Activity') {
          this.$router.push({ name: 'activities.view', params: { slug: object.model.slug }, query: { task: object.id }})
        }
        if (object.model_type == 'App\\Process\\Models\\Process') {
          this.$router.push({ name: 'processes.view', params: { slug: object.model.slug }, query: { task: object.id }})
        }
        if (object.model_type == 'App\\System\\Models\\System') {
          this.$router.push({ name: 'systems.view', params: { slug: object.model.slug, }, query: { task: object.id }})
        }
        if (object.model_type == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
          this.$router.push({ name: 'contracts.view', params: { slug: object.model.slug, }, query: { task: object.id }})
        }
        if (object.model_type == 'App\\Maintenance\\Policy\\Models\\Policy') {
          this.$router.push({ name: 'policies.view', params: { slug: object.model.slug, }, query: { task: object.id }})
        }
      },
      minimizeTask() {
        var element = document.getElementsByClassName('modal');
        element[0].classList.add("bottom-left");
        //this.submitForm = true
        this.$store.commit('storeLastClosedTask', this.selectedTask);
      },
      saveTask() {
        this.submitForm = true
        this.hideTaskModal()
      },
      showViewGuideModal(object) {
        this.selectedGuide = object
        this.viewGuideModal = true
      },
      closeViewGuideModal() {
        this.selectedGuide = ''
        this.viewGuideModal = false
      },
      showWatchVideoGuideModal(object) {
        this.selectedGuide = object
        this.viewWatchVideoModal = true
      },
      closeWatchVideoGuideModal() {
        this.selectedGuide = ''
        this.viewWatchVideoModal = false
      },
      completeTask() {
        this.buttonDisabled = true;
        this.submitForm = true
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        this.error = ''

        piincHttp.put('tasks/' + this.selectedTask.id, {
          status: 'completed'
        }).then(function(response) {
          self.buttonDisabled = false;

          if (self.taskList.length > 1) {
            let index = _.findIndex(self.taskList, function(o) { return o.id == self.selectedTask.id })
            if (index < self.taskList.length - 1) {
              self.selectedTask = self.taskList[index + 1]
            } else {
              self.selectedTask = self.taskList[0]
            }
            self.taskList.splice(index, 1);
            self.loadTaskById(self.selectedTask.id);
          } else {
            self.taskCompleted = true;
            self.$store.commit('storeTaskToolbarState', false);
            if (self.selectedTask.code == 'update_basic_info') {
              self.$store.commit('storeUpdatePage', true);
            }
            self.hideTaskModal()
          }
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      },
      previousTask() {
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        this.error = ''

        let index = _.findIndex(self.taskList, function(o) { return o.id == self.selectedTask.id })
        if (index > 0) {
          this.selectedTask = this.taskList[index - 1]
        } else {
          this.selectedTask = this.taskList[this.taskList.length - 1]
        }
        self.loadTaskById(this.selectedTask.id);
      },
      nextTask() {
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        this.error = ''

        let index = _.findIndex(self.taskList, function(o) { return o.id == self.selectedTask.id })
        if (index < this.taskList.length - 1) {
          this.selectedTask = this.taskList[index + 1]
        } else {
          this.selectedTask = this.taskList[0]
        }
        self.loadTaskById(self.selectedTask.id);
      },
      resetFile() {
        let imagefile = document.querySelector('#file');
        imagefile.value = '';
      },
      loadTaskById(id, ignorePopulate) {
        let self = this;
        piincHttp.get('tasks/' + id).then(function(response) {
          self.selectedTask = response.data;
          self.project_progress = self.selectedTask.project.user_progress.progress;
          self.loadGuides(self.selectedTask.code)
          if (!ignorePopulate) {
            self.populateForm()
          }
        }, function() {});
      },
      openDeleteAttachmentModal(object) {
        this.selectedFile = object
        this.showDeleteAttachmentModal = true
      },
      closeDeleteAttachmentModal () {
        this.selectedFile = {}
        this.showDeleteAttachmentModal = false;
        this.loadTaskById(this.selectedTask.id, true);
      },
      openDeleteLinkModal(object) {
        this.selectedLink = object
        this.showDeleteLinkModal = true
      },
      closeDeleteLinkModal () {
        this.selectedLink = {}
        this.showDeleteLinkModal = false;
        this.loadTaskById(this.selectedTask.id, true);
      },
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {
          responseType: 'blob',
          params:
            {
              client: this.getClient.slug,
              task: this.selectedTask.id
            }
        }).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      downloadScopeMedia(object){
        piincHttp.get('tasks/'+this.selectedTask.id+'/documents/' + object.id + '/download', {
          responseType: 'blob',
          params:
            {
              client: this.getClient.slug
            }
        }).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      onFileChange(file) {
        let files = file.target.files;
        let self = this;
        let formData = new FormData();
        let sizeError = false;

        for (var i = 0; i < files.length; i++) {
          // Equal to 10 MB
          if (files[i].size > 10485760) {
            sizeError = true;
          }
          formData.append('document[]', files[i]);
        }

        formData.append("name", "documents");
        formData.append("model_type", this.selectedTask.who_am_i);
        formData.append("model_id", this.selectedTask.id);

        if (sizeError) {
          this.error = this.$t('system.file_size')
        } else {
          piincHttp.post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function() {
            self.error = ''
            self.loadTaskById(self.selectedTask.id, true);
          }, function(error) {
            self.error = error.data.message;
            if (error.data.errors['document.0']) {
              self.error += ' ' + error.data.errors['document.0'][0]
            }
          })
        }
      },
      navigateToProject(task) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', task);
        this.$router.push({ name: 'projects.view', params: { slug: task.project.slug }})
      },
      getGuide(code) {
        if (code == 'update_mapping_description') {
          code = 'update_data_mapping_description'
        }
        let existingGuide = {}
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\Process\\Models\\Process') {
          existingGuide = _.find(this.myGuides, function(object) {
            return object.scope == code && object.enabled
          });
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\System\\Models\\System') {
          existingGuide = _.find(this.myGuides, function(object) {
            return object.scope == code && object.enabled
          });
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\Activity\\Models\\Activity') {
          existingGuide = _.find(this.myGuides, function(object) {
            return object.scope == code && object.enabled
          });
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
          existingGuide = _.find(this.myGuides, function(object) {
            return object.scope == code && object.enabled
          });
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy') {
          existingGuide = _.find(this.myGuides, function(object) {
            return object.scope == code && object.enabled
          });
        }

        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        let type = ''

        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\Process\\Models\\Process') {
          type = 'Process'
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\System\\Models\\System') {
          type = 'System'
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\Activity\\Models\\Activity') {
          type = 'Activity'
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
          type = 'Third party'
        }
        if (this.selectedTask && this.selectedTask.model && this.selectedTask.model.who_am_i == 'App\\Maintenance\\Policy\\Models\\Policy') {
          type = 'Policy'
        }

        if (code == 'update_mapping_description') {
          code = 'update_data_mapping_description'
        }

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: type,
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
            piincHttp.get(self.getWordpressLink + response.data.items[0].external_id).then(function(response) {
              self.wpGuide = response.data
            }, function() {});
          }
        }, function() {});
      },
    },
    created () {

    }
  }
</script>
